import React, { useEffect, useState } from 'react';
import { Label } from 'reactstrap';
import '../../assets/style/TaskAssign.css';
import { Button, Col, Row } from 'react-bootstrap';
import MSelect from '../../components/MSelect';
import MTextField from '../../components/MTextField';
import {
  CLICK_ACTIONS,
  DEFAULT_OPTION_LOCATION_SET_TARGET,
  TASK_ACTION,
} from '../../utils/Constant';
import SearchIcon from '@mui/icons-material/Search';
import {
  ColXsMdType,
  MapOptionType,
  MUILocationFilterType,
  SelectOptionType,
} from '../../utils/Types';
import moment from 'moment';
import {
  leadSelector,
  fetchLeadTypeBranchDrops,
} from '../../features/leadSlice';
import MUILocationFilter from '../../components/MUILocationFilter';
import { useAppDispatch, useAppSelector } from '../../store/redux-hooks';
import { VIEW_LEADCROPDETAILS_HEADER } from './LeadPageHelper';
import KTable from '../../components/KTable';
import {
  Autocomplete,
  FormControlLabel,
  IconButton,
  InputAdornment,
  Radio,
  RadioGroup,
  TextField,
} from '@mui/material';
import {
  getPincodeDropData,
  locationFilterSelector,
} from '../../features/locationFilterSlice';
import DatePicker from '../../components/KDatePicker';

const blankLocationCrop = {
  sl: '',
  pincode: '',
  location: '',
  district: '',
  state: null,
  city: '',
  statecode: '',
  statecd: '',
  pincodecol: '',
  did: '',
  zone: '',
  zones: '',
};

interface ICreateTaskCropPageProps {
  leadStatus?: any;
  disabled?: any;

  leadCropDetails?: any;
  leadCropList?: any;

  setLeadCropDetails: (data: any) => void;
  setLeadCropList: (data: any) => void;

  selectedLeadTypeId: any;
  defaultLocationOptions: any;

  zoneName: any;
  stateName: any;
  districtName: any;
  villageName: any;

  locationData: any;
  inputValue: any;
  searchTerm: any;
  ifPincode: any;
  pincodeData: any;
  selectedPincodeData: any;

  setZoneName: (data: any) => void;
  setStateName: (data: any) => void;
  setDistrictName: (data: any) => void;
  setVillageName: (data: any) => void;

  setLocationData: (data: any) => void;

  setInputValue: (data: any) => void;
  setSearchTerm: (data: any) => void;
  setIfPincode: (data: any) => void;
  setPincodeData: (data: any) => void;
  setSelectedPincodeData: (data: any) => void;
  leadBankTypeDropOptions: any;
  validateCropLead: () => Promise<boolean>;
}

const colSize: ColXsMdType = {
  xs: 6,
  md: 3,
};

const CropSectionPage: React.FunctionComponent<ICreateTaskCropPageProps> = ({
  leadStatus,
  disabled,
  leadCropDetails,
  leadCropList,
  setLeadCropDetails,
  setLeadCropList,
  selectedLeadTypeId,
  defaultLocationOptions,
  zoneName,
  stateName,
  districtName,
  villageName,
  locationData,
  inputValue,
  searchTerm,
  ifPincode,
  pincodeData,
  selectedPincodeData,
  setZoneName,
  setStateName,
  setDistrictName,
  setVillageName,
  setLocationData,
  setInputValue,
  setSearchTerm,
  setIfPincode,
  setPincodeData,
  setSelectedPincodeData,
  leadBankTypeDropOptions,
  validateCropLead,
}: ICreateTaskCropPageProps) => {
  const leadTypeTenantStatus: SelectOptionType[] =
    useAppSelector(leadSelector).leadTypeTenantStatus;
  const leadTypeLoaneeStatus: SelectOptionType[] =
    useAppSelector(leadSelector).leadTypeLoaneeStatus;
  const leadTypeAreaDescription: SelectOptionType[] =
    useAppSelector(leadSelector).leadTypeAreaDescription;
  const [leadTenantTypeDropOptions, setLeadTenantTypeDropOptions] = useState<
    SelectOptionType[]
  >([]);
  const [leadLoaneeTypeDropOptions, setLeadLoaneeTypeDropOptions] = useState<
    SelectOptionType[]
  >([]);
  const [leadAreaDescDropOptions, setLeadAreaDescDropOptions] = useState<
    SelectOptionType[]
  >([]);
  const leadBranchTypeDropOptions: SelectOptionType[] =
    useAppSelector(leadSelector).leadTypeBranchOptions;

  const allStates: MapOptionType = useAppSelector(
    locationFilterSelector
  ).statesData;
  const zoneOptionRaw: SelectOptionType[] = useAppSelector(
    locationFilterSelector
  ).zoneOptions;
  const districtData: MapOptionType = useAppSelector(
    locationFilterSelector
  ).districtData;
  const zoneOption =
    zoneOptionRaw && zoneOptionRaw.length > 1
      ? [DEFAULT_OPTION_LOCATION_SET_TARGET, ...zoneOptionRaw]
      : zoneOptionRaw;

  const dispatch = useAppDispatch();

  useEffect(() => {
    setLeadTenantTypeDropOptions(leadTypeTenantStatus);
  }, [leadTypeTenantStatus]);

  useEffect(() => {
    setLeadLoaneeTypeDropOptions(leadTypeLoaneeStatus);
  }, [leadTypeLoaneeStatus]);

  useEffect(() => {
    setLeadAreaDescDropOptions(leadTypeAreaDescription);
  }, [leadTypeAreaDescription]);

  const handleAddCropLead = async () => {
    const isValid = await validateCropLead();

    if (!isValid) {
      return;
    }

    console.log('locationData', locationData);

    setLeadCropList((prev: any) => [
      ...prev,
      {
        id: Date.now(),
        ...leadCropDetails,
        timeframeOfPurchase: moment(
          leadCropDetails?.timeframeOfPurchase
        ).format('YYYY-MM-DD'),
        state: Number(locationData.state),
        district: Number(locationData.district),
        city: Number(locationData.city),
        zone: Number(locationData.zone),
        pincode: locationData.pincode,
        zoneName,
        stateName,
        districtName,
        villageName,
        remove: 'Remove',
      },
    ]);

    console.log('villageName', villageName);

    // Clear inputs after adding
    setLeadCropDetails({
      firstname: '',
      lastname: '',
      contactNumber: '',
      alternateContactNumber: '',
      loaneeStatus: '',
      bankName: '',
      branchName: '',
      tenantStatus: '',
      surveyNumber: '',
      subSurveyNumber: '',
      timeframeOfPurchase: '',
      pastInsurance: '',
      insuredArea: '',
      areaDec: '',
      bankNameData: '',
      branchNamedata: '',
      areaDecName: '',
    });

    setLocationData(blankLocationCrop);

    setInputValue('');
    setPincodeData([]);
    setSearchTerm(false);

    setSelectedPincodeData({
      label: '',
      value: '',
    });
  };
  const handleRemoveCropLead = (id: number) => {
    setLeadCropList((prev: any) => prev.filter((item: any) => item.id !== id));
  };

  const handleSearchClick = async () => {
    if (inputValue?.length == 6) {
      await dispatch(getPincodeDropData(inputValue)).then((res) => {
        console.log('res-487', res);
        if (res?.payload?.status === 'SUCCESS') {
          if (res?.payload?.data?.length > 0) {
            const data =
              res?.payload?.data[0]?.map((item: any) => ({
                ...item,
                pincode: item?.pincodeId,
                mandal: item.mandalName,
                label:
                  item.mandalName +
                  ' - ' +
                  item.villageName +
                  ' - ' +
                  item.pincodeId,
                value: item?.pincodeId,
                id: item?.pincodeId,
              })) || [];
            setIfPincode(true);
            // setSelectedPincodeData(null);
            setPincodeData(data);
          }
        }
        if (res?.payload?.status === 'FAILED') {
          setPincodeData([]);
          setIfPincode(false);
        }
      });
    } else {
      setPincodeData([]);
      setIfPincode(false);
    }
  };

  return (
    <div className="inner-div">
      <Row className="align-items-center mb-3">
        <Col xs={6}>
          <Label className="header-style mb-0">Lead Details</Label>
        </Col>

        {leadStatus == TASK_ACTION.CREATE && (
          <Col xs={6} className="text-end">
            <Button
              variant="primary"
              onClick={handleAddCropLead}
              disabled={disabled}
            >
              Add Lead
            </Button>
          </Col>
        )}
      </Row>
      <Row className="mt-1">
        <Col xs={12} md={4}>
          <MTextField
            label="Lead First Name"
            required
            value={leadCropDetails?.firstname ?? ''}
            onChange={(e) => {
              const inputValue = e.target.value;
              setLeadCropDetails({
                ...leadCropDetails,
                firstname: inputValue,
              });
            }}
            disabled={disabled}
          />
        </Col>
        <Col xs={12} md={4}>
          <MTextField
            label="Lead Last Name"
            required={false}
            value={leadCropDetails?.lastname ?? ''}
            onChange={(e) => {
              const inputValue = e.target.value;
              setLeadCropDetails({
                ...leadCropDetails,
                lastname: inputValue,
              });
            }}
            disabled={disabled}
          />
        </Col>
        <Col xs={12} md={4} className="col-margin">
          <MTextField
            label="Contact Number"
            required
            value={leadCropDetails?.contactNumber}
            onChange={(data) => {
              if (data.target.value.length <= 10) {
                setLeadCropDetails({
                  ...leadCropDetails,
                  contactNumber: data.target.value,
                });
              }
            }}
            disabled={disabled}
          />
        </Col>
        <Col xs={12} md={4} className="col-margin mt-3">
          <MTextField
            label="Alternate Contact Number"
            required={false}
            value={leadCropDetails?.alternateContactNumber}
            onChange={(data) => {
              if (data.target.value.length <= 10) {
                setLeadCropDetails({
                  ...leadCropDetails,
                  alternateContactNumber: data.target.value,
                });
              }
            }}
            disabled={disabled}
          />
        </Col>
      </Row>
      <Row className="mt-4">
        <Col xs={12} md={5}>
          {leadStatus == TASK_ACTION.CREATE ? (
            <Autocomplete
              open={ifPincode}
              onOpen={() => setIfPincode(true)}
              onClose={() => setIfPincode(false)}
              options={pincodeData}
              getOptionLabel={(option) => String(option?.label)}
              value={selectedPincodeData ?? null}
              inputValue={inputValue}
              onInputChange={(event, newValue, reason) => {
                if (reason !== 'reset') {
                  const safeValue =
                    typeof newValue === 'string' ? newValue : '';
                  console.log('safeValue', safeValue);
                  setInputValue(safeValue);
                }
              }}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              onChange={async (event, newValue) => {
                console.log('newValue', newValue);
                if (newValue) {
                  const validZoneIds =
                    (await zoneOption.map((zone) => zone.value)) || [];
                  const validStateIds =
                    (await Object.values(allStates).flatMap((group) =>
                      group.map((item) => item.value)
                    )) || [];
                  const districtsLength =
                    (await Object.keys(districtData).length) ?? 0;
                  if (
                    !validZoneIds.includes(String(newValue.zoneId)) ||
                    !validStateIds.includes(String(newValue.stateId)) ||
                    districtsLength == 0
                  ) {
                    alert('This location isn’t within your assigned region');
                    setInputValue('');
                    setPincodeData([]);
                    setLocationData(blankLocationCrop);
                    return;
                  }
                  setSearchTerm(true);
                  setSelectedPincodeData(newValue);
                  setLocationData({
                    ...locationData,
                    zone: newValue.zoneId,
                    state: newValue.stateId,
                    district: newValue.districtId,
                    city: newValue.villageId,
                    pincode: newValue.pincode,
                  });
                  setZoneName(newValue.zoneName);
                  setStateName(newValue.stateName);
                  setDistrictName(newValue.districtName);
                  setVillageName(
                    newValue.mandalName
                      ? newValue.mandalName + '-' + newValue.villageName
                      : newValue.villageName
                  );
                } else {
                  setInputValue('');
                  setPincodeData([]);
                  setLocationData(blankLocationCrop);
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Pincode"
                  InputLabelProps={{
                    style: { fontSize: '0.8rem' },
                  }}
                  error={
                    inputValue !== '' &&
                    (!/^\d{6}$/.test(inputValue) ||
                      Number(inputValue) < 100001 ||
                      Number(inputValue) > 999999)
                  }
                  helperText={
                    inputValue !== '' &&
                    (!/^\d{6}$/.test(inputValue) ||
                      Number(inputValue) < 100001 ||
                      Number(inputValue) > 999999)
                      ? 'Enter a valid 6-digit pincode between 100001 and 999999'
                      : ''
                  }
                  variant="outlined"
                  id="searchPincode"
                  required
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        <InputAdornment position="end">
                          <IconButton onClick={handleSearchClick}>
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      </>
                    ),
                  }}
                />
              )}
              disabled={false}
            />
          ) : (
            <MTextField
              label="Pincode"
              required
              value={locationData.pincode ?? ''}
              numberOnly
              disabled
            />
          )}
        </Col>
      </Row>
      <div className="mt-3">
        <MUILocationFilter
          size={{
            zone: colSize,
            state: colSize,
            district: colSize,
            city: colSize,
          }}
          filterData={{
            zone: locationData.zone,
            state: locationData.state,
            district: locationData.district,
            city: locationData.city,
          }}
          setLocationFilter={(filter: MUILocationFilterType) => {
            setLocationData({
              ...locationData,
              zone: filter.zone,
              state: filter.state,
              district: filter.district,
              city: filter.city,
              pincode: filter.pincode ?? '',
            });
          }}
          disabled={disabled}
          required={true}
          defaultLocationOptions={defaultLocationOptions}
          selectedLeadTypeId={selectedLeadTypeId}
          setZoneName={(data) => setZoneName(data)}
          setStateName={(data) => setStateName(data)}
          setDistrictName={(data) => setDistrictName(data)}
          setVillageName={(data) => setVillageName(data)}
          setInputValue={(data: any) => {
            setInputValue(String(data));
          }}
          searchTerm={searchTerm}
          setSearchTerm={(data: any) => {
            setSearchTerm(data);
          }}
        />
      </div>
      <Row>
        {/* Loanee Status */}

        <Col xs={12} md={4} className="col-margin mt-3">
          <MSelect
            label="Loanee Status"
            required
            options={leadLoaneeTypeDropOptions}
            value={leadCropDetails?.loaneeStatus ?? ''}
            onChange={(e) => {
              setLeadCropDetails({
                ...leadCropDetails,
                loaneeStatus: e.target.value,
                bankName: '',
                branchName: '',
                bankNameData: '',
                branchNamedata: '',
              });
            }}
            disabled={disabled}
          />
        </Col>

        {/* Bank + Branch */}

        {leadCropDetails?.loaneeStatus === 'Loanee' && (
          <>
            <Col xs={12} md={4} className="col-margin mt-3">
              <MSelect
                label="Bank Name"
                required
                options={leadBankTypeDropOptions}
                value={leadCropDetails?.bankName ?? ''}
                onChange={(e) => {
                  const bankId = Number(e.target.value);
                  const selectedBank = leadBankTypeDropOptions.find(
                    (option: any) => Number(option.value) === bankId
                  );

                  dispatch(
                    fetchLeadTypeBranchDrops({
                      bankId,
                    })
                  );

                  setLeadCropDetails({
                    ...leadCropDetails,
                    bankName: bankId,
                    branchName: '',
                    bankNameData: selectedBank?.label || '',
                    branchNamedata: '',
                  });
                }}
                disabled={disabled}
              />
            </Col>

            <Col xs={12} md={4} className="col-margin mt-3">
              <MSelect
                label="Branch Name"
                required
                options={leadBranchTypeDropOptions}
                value={leadCropDetails?.branchName ?? ''}
                onChange={(e) => {
                  const selectedBranch = leadBranchTypeDropOptions.find(
                    (option: any) =>
                      Number(option.value) === Number(e.target.value)
                  );
                  setLeadCropDetails({
                    ...leadCropDetails,
                    branchName: Number(e.target.value),
                    branchNamedata: selectedBranch?.label || '',
                  });
                }}
                disabled={disabled}
              />
            </Col>
          </>
        )}

        {/* Tenant Status */}

        <Col xs={12} md={4} className="col-margin mt-3">
          <MSelect
            label="Landlord Status"
            required
            options={leadTenantTypeDropOptions}
            value={leadCropDetails?.tenantStatus ?? ''}
            onChange={(e) => {
              setLeadCropDetails({
                ...leadCropDetails,
                tenantStatus: e.target.value,
              });
            }}
            disabled={disabled}
          />
        </Col>

        {/* Survey Number */}

        <Col xs={12} md={4} className="col-margin mt-3">
          <MTextField
            label="Survey Number"
            required={
              selectedLeadTypeId && selectedLeadTypeId == 4 ? false : true
            }
            value={leadCropDetails?.surveyNumber ?? ''}
            onChange={(e) => {
              if (e.target.value.length <= 25) {
                setLeadCropDetails({
                  ...leadCropDetails,
                  surveyNumber: e.target.value,
                });
              }
            }}
            disabled={disabled}
          />
        </Col>

        {/* Sub Survey Number */}

        <Col
          xs={12}
          md={4}
          className={
            leadCropDetails?.loaneeStatus === 'Loanee'
              ? 'col-margin pt-3'
              : 'col-margin mt-4 pt-3'
          }
        >
          <MTextField
            label="Sub Survey Number"
            value={leadCropDetails?.subSurveyNumber ?? ''}
            onChange={(e) => {
              if (e.target.value.length <= 25) {
                setLeadCropDetails({
                  ...leadCropDetails,
                  subSurveyNumber: e.target.value,
                });
              }
            }}
            disabled={disabled}
          />
        </Col>

        {/* Timeframe */}

        <Col
          xs={12}
          md={4}
          className={
            leadCropDetails?.loaneeStatus == 'Loanee'
              ? 'col-margin mt-4'
              : 'col-margin mt-3'
          }
        >
          <DatePicker
            label="Timeframe Of Purchase"
            disabled={disabled}
            required={true}
            value={leadCropDetails?.timeframeOfPurchase}
            minDate={moment().toDate()}
            onChange={(date) => {
              setLeadCropDetails({
                ...leadCropDetails,
                timeframeOfPurchase: date,
              });
            }}
          />
        </Col>

        {/* Past Insurance */}

        <Col xs={12} md={4} className="col-margin mt-4">
          <div className="d-flex flex-column">
            <Label
              className="mb-2"
              style={{
                fontSize: '0.8rem',
                fontWeight: 400,
                color: 'rgba(0, 0, 0, 0.6)',
              }}
            >
              Past Insurance
            </Label>

            <RadioGroup
              row
              value={leadCropDetails?.pastInsurance ?? ''}
              onChange={(e) => {
                setLeadCropDetails({
                  ...leadCropDetails,
                  pastInsurance: e.target.value,
                });
              }}
            >
              <FormControlLabel
                value="yes"
                control={<Radio size="small" />}
                label="Yes"
                disabled={disabled}
                sx={{
                  '& .MuiFormControlLabel-label': {
                    fontSize: '0.8rem',
                  },
                }}
              />

              <FormControlLabel
                value="no"
                control={<Radio size="small" />}
                label="No"
                disabled={disabled}
                sx={{
                  '& .MuiFormControlLabel-label': {
                    fontSize: '0.8rem',
                  },
                }}
              />
            </RadioGroup>
          </div>
        </Col>

        {/* Insured Area */}
        <Col
          xs={12}
          md={4}
          className={
            leadCropDetails?.loaneeStatus == 'Loanee'
              ? 'col-margin mt-4'
              : 'col-margin mt-2'
          }
        >
          <MTextField
            label="Insured Area"
            value={leadCropDetails?.insuredArea ?? ''}
            onChange={(e) => {
              if (e.target.value.length <= 10) {
                setLeadCropDetails({
                  ...leadCropDetails,
                  insuredArea: e.target.value,
                });
              }
            }}
            disabled={disabled}
          />
        </Col>

        {/* Area Description */}

        <Col
          xs={12}
          md={4}
          className={
            leadCropDetails?.loaneeStatus == 'Loanee'
              ? 'col-margin mt-1'
              : 'col-margin mt-2'
          }
        >
          <MSelect
            label="Area Description"
            required={false}
            options={leadAreaDescDropOptions}
            value={leadCropDetails?.areaDec ?? ''}
            onChange={async (e) => {
              const selectedAreaDescription =
                await leadAreaDescDropOptions?.find(
                  (option: any) =>
                    Number(option.value) === Number(e.target.value)
                );
              setLeadCropDetails({
                ...leadCropDetails,
                areaDec: e.target.value,
                areaDecName: selectedAreaDescription?.label || '',
              });
            }}
            disabled={disabled}
          />
        </Col>
      </Row>
      {leadCropList.length > 0 ? (
        <Row className="mt-4">
          <Col xs={12} md={12}>
            <KTable
              data={leadCropList}
              tableParentClass=""
              columnHeader={VIEW_LEADCROPDETAILS_HEADER}
              isLoading={false}
              showNoDataFoundMsg={false}
              onAction={(action, rowData) => {
                if (rowData?.action === CLICK_ACTIONS.DELETE) {
                  handleRemoveCropLead(action.id);
                }
              }}
            />
          </Col>
        </Row>
      ) : null}
    </div>
  );
};

export default CropSectionPage;
